import { pdfjs } from 'react-pdf'

export function initializePdfServiceWorker (): void {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
}
